// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__wE23E","vLegacy":"SelectSecondary_vLegacy__3CLrx","error":"SelectSecondary_error__waFzU","disabled":"SelectSecondary_disabled__2zAzf"};